import { Box, InputBase, Typography } from "@mui/material";
import { formatCurrencyInput } from "@helpers/funciones";

interface Props {
  /** Con separadores de miles (`"1,200"`); `onChange` lo regresa con el mismo formato. */
  value: string;
  onChange: (value: string) => void;
  width: number | string;
  testId: string;
}

/**
 * Replica `.mp-money` del perfil de ingresos: monto en pesos alineado a la derecha, con separadores
 * de miles mientras se teclea y el anillo de foco en el color de marca.
 */
export const InputMoney = ({ value, onChange, width, testId }: Props) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: "6px",
      height: 44,
      width,
      // Sin `CssBaseline` el `Box` es `content-box`: el padding y el borde se sumarían al ancho y se desborda.
      boxSizing: "border-box",
      px: "12px",
      border: "1px solid",
      borderColor: "tokens.borderStrong",
      borderRadius: "10px",
      bgcolor: "background.paper",
      "&:focus-within": {
        borderColor: "primary.main",
        boxShadow: (theme) => `0 0 0 3px color-mix(in oklab, ${theme.palette.primary.main} 14%, transparent)`,
      },
    }}
  >
    <Typography variant="body2" color="tokens.textTertiary">
      $
    </Typography>
    <InputBase
      value={value}
      placeholder="0"
      onChange={(e) => onChange(formatCurrencyInput(e.target.value))}
      inputProps={{ inputMode: "numeric", "data-testid": testId }}
      sx={{
        flex: 1,
        minWidth: 0,
        "& input": {
          textAlign: "right",
          p: 0,
          fontFamily: "Outfit",
          fontSize: 15,
          fontWeight: 600,
          color: "primary.dark",
          fontVariantNumeric: "tabular-nums",
        },
      }}
    />
  </Box>
);
